import { useEffect } from 'react';
import { useClientLogin } from '@/providers/ClientLogin.provider';
import { usePermissions } from '@/providers/Permissions.provider';
import * as vp from 'vopay';
const useZendesk = () => {
  const { isAuthenticated, response } = useClientLogin();
  const { permissions } = usePermissions();
  useEffect(() => {
    const scriptId = 'ze-snippet';
    const scriptSrc = 'https://static.zdassets.com/ekr/snippet.js?key=eacaff06-0a47-4fe6-b343-a6cd1fba3406';

    const shouldLoadZendesk = permissions.CreateSupportTickets && isAuthenticated && response.ChatSupportEnabled;

    if (shouldLoadZendesk) {
      if (!document.getElementById(scriptId)) {
        vp.loadScriptByURL(scriptId, scriptSrc)
          .then(() => {
            if (window.zE) {
              window.zE('messenger', 'resetWidget');
            }
          })
          .catch((error) => {
            console.error('Failed to load HubSpot script:', error);
          });
      }
    } else {
      // destroy the chat and clean up
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
      if (window.zE) {
        delete window.zEACLoaded;
        delete window.zE;
        delete window.zEmbed;
        const webWidgetElement = document.querySelector('[data-product="web_widget"]');
        if (webWidgetElement) {
          webWidgetElement.remove();
        }
        const launcherParentParent = document.querySelector('#launcher')?.parentElement?.parentElement;
        if (launcherParentParent) {
          launcherParentParent.remove();
        }
      }
    }
  }, [permissions.CreateSupportTickets, isAuthenticated, response.ChatSupportEnabled]);

  useEffect(() => {
    if (window.zE) {
      window.zE('messenger', 'resetWidget');
    }
  }, [response.AccountID]);
};

export default useZendesk;
